import React from 'react';
import { cn } from '../cn';
import PageBackButton from './PageBackButton';
const PageHeader = ({ title, description, actions, className, back, titleAddon, }) => {
    return (React.createElement("div", { className: cn('flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between sm:gap-6', className) },
        React.createElement("div", { className: "min-w-0" },
            React.createElement("div", { className: cn('min-w-0', back ? 'flex items-start gap-3' : 'space-y-1') },
                back ? React.createElement(PageBackButton, { label: back.label, onClick: back.onClick }) : null,
                React.createElement("div", { className: cn('min-w-0', back ? 'space-y-1' : '') },
                    React.createElement("div", { className: cn('min-w-0', titleAddon ? 'flex items-center gap-2' : '') },
                        titleAddon,
                        React.createElement("h1", { className: "min-w-0 text-3xl font-bold tracking-tight text-foreground" }, title)),
                    description != null && description !== '' ? (React.createElement("p", { className: "max-w-2xl text-muted-foreground" }, description)) : null))),
        actions != null ? React.createElement("div", { className: "flex shrink-0 flex-wrap items-center gap-2" }, actions) : null));
};
export default PageHeader;
